import { ActionItem, Box, Text } from '@factorialco/deprecated-design-system'
import xor from 'lodash/xor'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import InlineSearch from 'modules/core/components/InlineSearch'
import ScrollableItem from 'modules/core/components/ScrollableItem'
import ScrollableList from 'modules/core/components/ScrollableList'
import useSearch from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'

import groupsCollection from 'modules/dashboard/store/collections/communities/Groups'
import type Group from 'modules/dashboard/store/models/communities/Group'

interface ItemProps {
  group: Group
  onSelect: (id: number) => void
  selected: boolean
}

const Item = observer(({ selected, group, onSelect }: ItemProps) => {
  return (
    <ScrollableItem key={group.attributes.id}>
      <ActionItem
        onClick={() => onSelect(group.attributes.id)}
        selected={selected}
        showIcon={false}
      >
        <Text.Normal weight="medium">{group.attributes.title}</Text.Normal>
      </ActionItem>
    </ScrollableItem>
  )
})

function BlankSlate() {
  return (
    <Text.Normal>{i18n.t('posts.communities.group_picker.group_selector.blank_slate')}</Text.Normal>
  )
}

interface GroupsListProps {
  groups: Group[]
  onSelect: (id: number) => void
  selectedGroupId: number | null
}

const GroupsList = observer(({ groups, onSelect, selectedGroupId }: GroupsListProps) => {
  if (!groups.length) return <BlankSlate />

  return (
    <>
      {groups.map((group) => (
        <Item
          key={group.get('id')}
          group={group}
          onSelect={onSelect}
          selected={selectedGroupId === group.get('id')}
        />
      ))}
    </>
  )
})
interface Props {
  selectedGroupId: number | null
  onSelect: (id: number) => void
}

// TODO: DRY
// There is a similar component in pages/Dashboard/components/Groups/GroupPicker
// The main difference between this one and the other is that this only permits
// the selection of one group, including only those where the user doesn't
// pertain to. The other one permits multiple group selection including only
// those groups where the user pertains to, including also some buttons
const GroupSelector = observer(({ selectedGroupId, onSelect }: Props) => {
  const { search, onSearch } = useSearch()
  const groupsFromUser = groupsCollection.fromCurrentUser
  const groups = xor(groupsCollection.models, groupsFromUser || [])

  const filteredGroups = groups.filter((group) => !search || matchText(search, group.get('title')))

  return (
    <Box gap="s16">
      <BoxList>
        <InlineSearch onSearch={onSearch} search={search} />
        <ScrollableList>
          <GroupsList
            selectedGroupId={selectedGroupId}
            groups={filteredGroups}
            onSelect={onSelect}
          />
        </ScrollableList>
      </BoxList>
    </Box>
  )
})

export default GroupSelector
